import {
  SET_USERS,
  SET_THERAPIST_EMAIL_LOG,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
  count: 0,

  therapistEmailLog: {
    list: [],
    count: 0,
  }

};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_USERS:
      return {
        ...state,
        list: action.data.list,
        count: action.data.count || state.count,
      }

    case SET_THERAPIST_EMAIL_LOG:
      return {
        ...state,
        therapistEmailLog: {
          list: action.data.list,
          count: action.data.count || state.therapistEmailLog.count,
        }
      }

    default:
      return state

  }
}
